import { ObjectDirective } from 'vue'
import { AuthenticatedUser } from '../../modules/_base/auth/auth.service.interface'
import authStoreGetters from '../../modules/authentication/store/getters'

/**
 * `v-can` — removes the element unless the user holds the permission.
 *
 * Vue 3 renamed the hooks and dropped `DirectiveOptions`/`DirectiveFunction`: `inserted` is
 * `mounted`, and the element is the first argument rather than something to find on the vnode
 * (`vnode.elm` is gone; `vnode.el` exists but `el` is handed in directly).
 */
export const getDirective = (roleType: number): ObjectDirective => {
  const directive: ObjectDirective = {
    // Runs once the element is in the DOM. Any earlier and it would show until the next render.
    mounted: (el, binding) => {
      if (binding.value === '') return

      const
        authenticatedUser = authStoreGetters.authenticatedUser as AuthenticatedUser,
        mimicUser = authStoreGetters.mimicUser as AuthenticatedUser,
        userToCheck = mimicUser || authenticatedUser,
        // If we're checking a perm or a role
        userHasPermission = binding.arg !== void 0 && userToCheck.permissionQuery.can(binding.arg, binding.value, roleType)

      if (!userHasPermission) {
        // Doesn't have permission to access this item so remove the element from the dom
        el.parentElement?.removeChild(el)
      }
    }
  }

  return directive
}
